import { requestTypes } from '@/constants'

function action(type, payload = {}, error = null, showError = true) {
	return { type, payload, error, showError, allowRetry: false }
}

function actionRetryable(type, payload = {}, error = null, showError = false) {
	return { type, payload, error, showError, allowRetry: true }
}

function createRequestTypes(base) {
	return [requestTypes.REQUEST, requestTypes.SUCCESS, requestTypes.FAILURE].reduce((acc, type) => {
		acc[type] = `${base}_${type}`
		return acc
	}, {})
}

function isFailureAction(actionType) {
	return /_FAILURE$/.test(actionType)
}

function isRequestAction(actionType) {
	return /_REQUEST$/.test(actionType)
}

function isSuccessAction(actionType) {
	return /_SUCCESS$/.test(actionType)
}

export { action, actionRetryable, createRequestTypes, isFailureAction, isRequestAction, isSuccessAction }
